const notFound = {
    notFoundMessage: 'This page does not exist',
    description: 'The link may be broken, or the page may have moved. Head back and try from there.',
    backHome: 'Back to home',
};

export default notFound;
